import { useApp } from '../store.js';

/** Кнопка Share Victory: пока готовится сообщение — «Готовим…», при ошибке — подсказка. */
export function ShareButton({ label, onShare }: { label: string; onShare: () => void }) {
  const sharing = useApp((s) => s.sharing);
  return (
    <>
      <button
        type="button"
        className="play play--small play--share"
        disabled={sharing === 'busy'}
        onClick={onShare}
      >
        {sharing === 'busy' ? 'Готовим…' : label}
      </button>
      {sharing === 'failed' && (
        <p className="field__hint field__hint--error">Не получилось поделиться. Попробуйте ещё раз</p>
      )}
    </>
  );
}
